import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Stethoscope, Users } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function CabinetJoin() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { user, loading } = useAuth();
  const token = params.get("token");
  const [state, setState] = useState({ busy: false, done: false, error: null, cabinet: null });
  const attempted = useRef(false);

  useEffect(() => {
    if (loading) return;
    if (!token) { setState((s) => ({ ...s, error: "Lien invalide" })); return; }
    if (!user) {
      nav(`/login?next=/cabinet/join?token=${token}`, { replace: true });
      return;
    }
    if (attempted.current) return;
    attempted.current = true;
    (async () => {
      setState((s) => ({ ...s, busy: true }));
      try {
        const { data } = await api.post(`/cabinet/accept?token=${encodeURIComponent(token)}`);
        setState({ busy: false, done: true, error: null, cabinet: data });
        toast.success(`Bienvenue dans ${data.cabinet_name || "le cabinet"}`);
      } catch (e) {
        setState({ busy: false, done: false, error: e?.response?.data?.detail || "Erreur", cabinet: null });
      }
    })();
  }, [loading, user, token, nav]);

  return (
    <div className="min-h-screen bg-[#F4F7FB] flex flex-col">
      <header className="pt-8 pb-4 px-6 flex items-center gap-2">
        <Stethoscope size={22} weight="duotone" className="text-[#3A8FA5]" />
        <span className="font-serif text-xl text-[#1E3A5F]">Questiomed</span>
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md w-full text-center">
          <Users size={48} weight="duotone" className="text-[#3A8FA5] mx-auto mb-6" />
          {state.busy && <p className="text-[#5F758F]">Rattachement en cours…</p>}
          {state.error && (
            <>
              <h1 className="font-serif text-3xl mb-3 text-[#1E3A5F]">Invitation invalide</h1>
              <p className="text-[#5F758F] mb-6">{state.error}</p>
              <Button onClick={() => nav("/dashboard")} className="rounded-full bg-[#1E3A5F] hover:bg-[#0F2340] text-white">Retour au tableau de bord</Button>
            </>
          )}
          {state.done && (
            <>
              <h1 className="font-serif text-4xl mb-3 text-[#1E3A5F]">Bienvenue !</h1>
              <p className="text-[#5F758F] mb-6">Vous avez rejoint <strong>{state.cabinet.cabinet_name}</strong>. Les modèles partagés sont désormais disponibles dans votre bibliothèque.</p>
              <Button onClick={() => nav("/cabinet")} className="rounded-full bg-[#1E3A5F] hover:bg-[#0F2340] text-white">Voir le cabinet</Button>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
